<template>
    <div id="app" v-if="subsidiaryIsLoaded">
        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>

<script>

export default {
    name: 'App',
    computed: {
        subsidiaryIsLoaded(){
            return this.$root.whitelabel.state.subid
        }
    },
    updated() {
        if (['login', 'register', 'password_forget', 'pasword_reset', 'password_reset'].includes(this.$route.name)) {
            if (this.$root.user.isLoggedIn()) {
                this.$goTo('cdb-dashboard', this.$route.params, this.$route.query)
            }
        } else {
            if (!this.$root.user.isLoggedIn() && this.$root.whitelabel.state.settings.is_b2b) {
                this.$goTo('login', this.$route.params, this.$route.query)  
            }
        }
    }
}
</script>
